import React from 'react';
import { Box, Container, Typography, Paper, Slide, Fade } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme as useAppTheme } from '../ThemeContext';
import GradientButton from './buttons/GradientButton';
import HomeIcon from '@mui/icons-material/Home';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { mode } = useAppTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: mode === 'dark' ? '#121212' : '#ffffff',
        position: 'relative'
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            minHeight: 'calc(100vh - 80px)',
            pt: 8
          }}
        >
          <Slide direction="down" in={true} timeout={800}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%'
              }}
            >
              {/* Logo */}
              <Box
                component="img"
                src="/neatschedule.png"
                alt="Neat Schedule Logo"
                sx={{
                  width: 240,
                  height: 'auto',
                  mb: 4,
                  filter: mode === 'dark' 
                    ? 'drop-shadow(0 0 20px rgba(255, 255, 255, 0.2))'
                    : 'drop-shadow(0 0 20px rgba(0, 0, 0, 0.1))'
                }}
              />

              <Paper 
                elevation={0}
                sx={{ 
                  p: 4, 
                  textAlign: 'center',
                  backgroundColor: 'transparent',
                  width: '100%'
                }}
              >
                <Fade in={true} timeout={1000}>
                  <Typography 
                    variant="h4" 
                    sx={{ 
                      fontWeight: 700,
                      mb: 1,
                      color: mode === 'dark' ? '#ffffff' : '#1a1a1a'
                    }}
                  >
                    Access Denied
                  </Typography>
                </Fade>
                
                <Fade in={true} timeout={1200}>
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      mb: 4,
                      color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
                      fontSize: '1.1rem'
                    }}
                  >
                    You don’t have permission to access this page. If you think this is a mistake, please contact your administrator.
                  </Typography>
                </Fade>

                <Fade in={true} timeout={1400}>
                  <Box>
                    <GradientButton
                      onClick={() => navigate('/app/overview')}
                      size="large"
                      startIcon={<HomeIcon />}
                    >
                      Return to Overview
                    </GradientButton>
                  </Box>
                </Fade>
              </Paper>
            </Box>
          </Slide>
        </Box>
      </Container>
    </Box>
  );
};

export default Unauthorized; 